// IMPORTS
// OHS
import { OHSFormItem, OHSFormSubmit, OHSFormDataExtractor, OHSFormDataClearer, OHSFormSelectBuilder } from '../../../../../onehivesystems/js/OHSForm';
import OHSCRUD from '../../../../../onehivesystems/js/OHSCRUD';


// COMPONENT
export default function Migrations (props) {
   // Functions
   const migratePort = function (method) {
      // Build Payload
      var master = {};
      var ports = JSON.parse(OHSFormDataExtractor('oneport-device-migrations'));
      master['method'] = method;
      master['source_port'] = ports.source_port;
      master['destination_port'] = ports.destination_port;
      master['portinfo'] = JSON.parse(OHSFormDataExtractor('oneport-device-migrations-portinfo'));
      master['fields'] = JSON.parse(OHSFormDataExtractor('oneport-device-migrations-fields'));
      
      // Perform Request
      OHSCRUD({
         url: '/v1/oneport/ports/migrations',
         method: 'PUT',
         payload: JSON.stringify(master),
         success: function (data) {
            props.parent.getPorts(); // refresh ports list
         },
         setOHSLoading: props.onehive.setLoading,
         setOHSPopup: props.onehive.setPopup,
         showSuccessPopup: true,
         setOHSConfirmation: props.onehive.setConfirmation,
         confirmMessage: "Are you sure you wish to " + method + " these ports? Performing this action will overwrite the information on the source and/or destination port and cannot be undone."
      });
   }

   // Component
   return (
      <div id='oneport-device-migrations' className='oneport-device-migrations'>
         <OHSFormItem onehive={props.onehive} title="Source Port">
            <OHSFormSelectBuilder onehive={props.onehive} content={props.parent.ports} field={"name"} blank={false} ohsformdata='source_port' />
         </OHSFormItem>
         <OHSFormItem onehive={props.onehive} title="Destination Port">
            <OHSFormSelectBuilder onehive={props.onehive} content={props.parent.ports} field={"name"} blank={false} ohsformdata='destination_port' />
         </OHSFormItem>
         <div id='oneport-device-migrations-portinfo' className='oneport-device-migrations-section'>
            <p>General Information to Migrate</p>
            <OHSFormItem onehive={props.onehive} title="Port Number">
               <input type='checkbox' className='ohsinput' data-ohsformdata='name' />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Port Type">
               <input type='checkbox' className='ohsinput' data-ohsformdata='port_type' />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Port Mapped Device">
               <input type='checkbox' className='ohsinput' data-ohsformdata='mapped_device' />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Port Expiration">
               <input type='checkbox' className='ohsinput' data-ohsformdata='expiration' />
            </OHSFormItem>
            <OHSFormItem onehive={props.onehive} title="Port Broken Status">
               <input type='checkbox' className='ohsinput' data-ohsformdata='unusable' />
            </OHSFormItem>
         </div>
         <div id='oneport-device-migrations-fields' className='oneport-device-migrations-section'>
            <p>Fields to Migrate</p>
            {props.parent.fields && props.parent.fields.length > 0 && props.parent.fields.map(function (field, i) {
               return (
                  <OHSFormItem onehive={props.onehive} key={`oneport-device-migrations-field-${i}`} title={field.name}>
                     <input type='checkbox' className='ohsinput' data-ohsformdata={field.id} />
                  </OHSFormItem>
               )
            })}
         </div>
         <OHSFormSubmit onehive={props.onehive} custom={[
            {
               title: "Copy",
               action: function () {
                  migratePort('copy');
               },
               class: "ohsbtn-success"
            },
            {
               title: "Move",
               action: function () {
                  migratePort('move');
               },
               class: "ohsbtn-success"
            },
            {
               title: "Swap",
               action: function () {
                  migratePort('swap');
               },
               class: "ohsbtn-success"
            },
            {
               title: "Clear",
               action: function () {
                  OHSFormDataClearer('oneport-device-migrations');
               },
               class: "ohsbtn"
            }
         ]} />
      </div>
   );
}